import React, { useState, useEffect } from 'react'
import { arrayOf, bool, string, func } from 'prop-types'
import tabDataProp from 'utils/prop_types/TabData'

import TabsNavigator from 'components/molecules/TabsNavigator'
import TabsContent from 'components/molecules/TabsContent'

const WindowTabs = ({ tabs, activeId, fullContent, onTabSelect }) => {
  const getActiveId = () => activeId || tabs[0].id
  const [selectedId, setSelectedId] = useState(getActiveId())

  const selectTab = (id) => {
    setSelectedId(id)
    onTabSelect && onTabSelect(id)
  }

  useEffect(() => {
    if (selectedId !== activeId) {
      setSelectedId(activeId)
    }
  }, [activeId])

  return (
    <div className="window-tabs">
      <TabsNavigator
        tabs={tabs}
        activeId={selectedId}
        onTabSelect={selectTab}
      />
      <TabsContent
        tabs={tabs}
        activeId={selectedId}
        fullContent={fullContent}
      />
      <style jsx>
        {`
          .window-tabs {
            width: 100%;
            border-radius: 8px;
            box-shadow: 0 4px 16px 0 rgba(0, 0, 0, 0.1);
            background-color: #ffffff;
          }
        `}
      </style>
    </div>
  )
}



WindowTabs.propTypes = {
  tabs: arrayOf(tabDataProp),
  activeId: string,
  onTabSelect: func,
  fullContent: bool,
}

export default WindowTabs
